import type { SVGProps } from "react";

const SvgCreditasLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250 52" {...props}>
    <defs>
      <linearGradient
        id="linear-gradient"
        x1={25.8}
        y1={50.59}
        x2={25.8}
        y2={1}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#01579b" />
        <stop offset={1} stopColor="#4dd0e1" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-2"
        x1={23.17}
        y1={43.74}
        x2={23.17}
        y2={7.84}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" />
        <stop offset={0.28} stopColor="#f6f6f6" />
        <stop offset={0.73} stopColor="#ddd" />
        <stop offset={1} stopColor="#ccc" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-3"
        x1={23.89}
        y1={38.77}
        x2={23.89}
        y2={12.82}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#ccc" />
        <stop offset={0.27} stopColor="#ddd" />
        <stop offset={0.72} stopColor="#f6f6f6" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <style>{".cls-2{fill:#01579b}"}</style>
    </defs>
    <path
      className="cls-2"
      d="M99.56 1h-7.23l-8.4 22.31h6.53l1.1-3.21h8.8l1.1 3.21h6.52zm-6.61 14.52 2.99-8.4 2.84 8.4h-5.84Zm22.99-5.12 9.44 12.91h5.55V1h-5.78v12.28L116.11 1h-5.92v22.31h5.75zm-34.57 3.11c-.81-1.05-1.82-1.66-3.03-1.84 1.09-.24 2-.81 2.73-1.72.73-.9 1.09-2.02 1.09-3.34 0-.97-.25-1.88-.73-2.74-.49-.86-1.23-1.55-2.21-2.08S77.04 1 75.64 1H62.99v22.31h13.05c1.41 0 2.6-.27 3.6-.83.99-.55 1.73-1.29 2.23-2.22.49-.93.74-1.95.74-3.08 0-1.4-.41-2.62-1.22-3.68ZM68.74 5.58h5.59c.58 0 1.05.18 1.42.56.37.37.55.84.55 1.42s-.19 1.08-.55 1.45c-.37.37-.84.56-1.42.56h-5.59V5.59Zm7.41 12.52q-.585.63-1.62.63h-5.79v-4.58h5.79c.69 0 1.23.22 1.62.65s.59.98.59 1.64-.2 1.24-.59 1.66M171.71 1h-7.23l-8.4 22.31h6.52l1.1-3.21h8.8l1.1 3.21h6.52zm-6.61 14.52 2.99-8.4 2.84 8.4h-5.84Z"
    />
    <path
      className="cls-2"
      d="M155.73 1h-7.1l-6.86 9.17V1h-5.75v22.31h5.75v-6.52l1.51-1.87 5.85 8.39h7.06l-9.13-11.87zM70.46 33.42c.94-.61 2.01-.92 3.21-.92 1.05 0 2.01.31 2.89.93q1.32.945 1.89 2.31l4.95-2.34c-.87-1.61-2.1-2.92-3.68-3.95s-3.6-1.54-6.05-1.54c-2.27 0-4.33.48-6.17 1.45s-3.28 2.33-4.33 4.08-1.57 3.75-1.57 6 .52 4.26 1.57 6.01 2.49 3.11 4.33 4.08 3.9 1.46 6.17 1.46c2.45 0 4.48-.52 6.07-1.55s2.81-2.34 3.66-3.94l-4.95-2.34q-.57 1.38-1.89 2.31c-.88.63-1.85.94-2.89.94-1.2 0-2.27-.31-3.21-.92s-1.67-1.45-2.21-2.5c-.54-1.06-.8-2.24-.8-3.54s.27-2.47.8-3.53a6.34 6.34 0 0 1 2.21-2.51Zm30.47 8.98c1.2-.42 2.25-1.2 3.13-2.32.88-1.13 1.32-2.58 1.32-4.37 0-1.41-.3-2.67-.92-3.8-.61-1.13-1.51-2.01-2.68-2.66s-2.56-.97-4.17-.97H86.44v22.31h5.75V43.1h2.94l3.75 7.49h6.59l-4.55-8.19Zm-2.21-4.63c-.54.5-1.19.75-1.97.75H92.2v-5.65h4.55c.78 0 1.44.25 1.97.75.54.5.8 1.18.8 2.06s-.27 1.59-.8 2.1Zm97.34-9.48h-7.23l-8.4 22.31h6.53l1.1-3.21h8.8l1.1 3.21h6.52l-8.43-22.31Zm-6.6 14.52 2.99-8.4 2.85 8.4zm-7.88-14.52h-18.23v4.58h6.25V50.6h5.75V32.87h6.23zm41.25 11.4a7.8 7.8 0 0 0-3.1-2.09c-1.18-.43-2.63-.83-4.35-1.19-1.38-.37-2.37-.69-2.96-.96s-.89-.66-.89-1.18q0-.81.6-1.29c.4-.32 1.01-.48 1.81-.48 1.14 0 2.28.19 3.43.58s2.18.97 3.09 1.72l3.14-3.99c-1.18-.96-2.54-1.68-4.08-2.17s-3.2-.73-4.99-.73-3.42.32-4.77.97-2.37 1.51-3.08 2.6a6.4 6.4 0 0 0-1.05 3.54c0 1.7.44 3.04 1.32 4.01s1.91 1.67 3.1 2.08c1.18.42 2.65.8 4.41 1.15 1.34.29 2.31.58 2.91.86q.9.42.9 1.29c0 .87-.28 1.06-.85 1.44s-1.34.57-2.33.57c-1.43 0-2.75-.27-3.98-.82s-2.27-1.26-3.14-2.12l-3.05 4.22c2.48 2.2 5.78 3.31 9.9 3.31 2.94 0 5.23-.67 6.86-2.02s2.44-3.16 2.44-5.44c0-1.6-.44-2.89-1.32-3.85ZM109.13 50.6h16.35v-4.58h-10.6v-4.66h10.37v-4.58h-10.37v-3.91h10.6v-4.58h-16.35zm40.17-17.1c-1.03-1.67-2.45-2.96-4.28-3.87-1.83-.9-3.92-1.35-6.26-1.35h-9.37v22.31h9.4c2.32 0 4.39-.45 6.22-1.35s3.25-2.2 4.28-3.88 1.54-3.66 1.54-5.94-.51-4.25-1.54-5.92Zm-5.08 9.22c-.49 1-1.2 1.8-2.14 2.4s-2.04.9-3.31.9h-3.62V32.87h3.65c1.96 0 3.48.61 4.55 1.83s1.61 2.8 1.61 4.73c0 1.19-.25 2.29-.74 3.3Zm10.06-14.43h5.75V50.6h-5.75z"
    />
    <path
      d="M50.59 37.33c0 3.66-1.48 6.97-3.89 9.37a13.17 13.17 0 0 1-9.36 3.89H1V1h36.35c3.66 0 6.97 1.48 9.36 3.88 2.4 2.39 3.89 5.71 3.89 9.36 0 4.96-2.72 9.27-6.74 11.55 4.02 2.27 6.74 6.6 6.74 11.54Z"
      style={{
        fill: "url(#linear-gradient)",
      }}
    />
    <path
      d="m34.96 34.97 3.53 3.52a17.9 17.9 0 0 1-12.7 5.25c-9.91 0-17.95-8.04-17.95-17.95S15.88 7.84 25.8 7.84c4.96 0 9.44 2.01 12.7 5.26l-7.05 7.05a7.98 7.98 0 0 0-5.65-2.35c-4.41 0-7.99 3.58-7.99 7.99s3.58 7.99 7.99 7.99c2.2 0 4.2-.9 5.65-2.35l3.52 3.53Z"
      style={{
        fill: "url(#linear-gradient-2)",
      }}
    />
    <path
      d="m31.45 31.44 3.52 3.53a12.93 12.93 0 0 1-9.17 3.8c-7.17 0-12.98-5.81-12.98-12.98s5.81-12.97 12.98-12.97c3.58 0 6.82 1.45 9.17 3.8l-3.52 3.52a7.98 7.98 0 0 0-5.65-2.35c-4.41 0-7.99 3.58-7.99 8s3.58 7.99 7.99 7.99c2.2 0 4.2-.9 5.65-2.35Z"
      style={{
        fill: "url(#linear-gradient-3)",
      }}
    />
  </svg>
);
export default SvgCreditasLogo;
